import { Component, Input, Output, EventEmitter, ElementRef, OnInit } from '@angular/core';
import { DataService } from 'src/app/@core/services/data.service';

@Component({
    selector: 'app-editor-custom-component-eventos-config',
    templateUrl: 'eventos-config.component.html'
})
export class EventosConfigComponent implements OnInit {

    @Input() item: any;
    @Input() layout: any;
    @Input() customData: any;
    @Output() public sendEvent = new EventEmitter<any>();

    public companies: any;

    constructor(
        private elRef: ElementRef,
        public dataService: DataService,
    ) {
    }

    ngOnInit(): void {
        if (this.isMulti()) {
            this.getCompanies();
        }
        else {
            if (this.item.companies) {
                delete(this.item.companies);
            }
        }
    }

    emitSendEvent() {
        this.sendEvent.emit();
    }

    uploadSubmited($event: any): void {
        this.item.url = ($event.data) ? $event.data.url : $event.url;
    }

    getPhoto($event: any): void {
        this.item.banner = $event.path;
    }

    setAlign(element: any, align: string): void {
        element.align = align;
    }

    setTitleAlign(align: string): void {
        this.item.titleAlign = align;
    }

    setSubtitleAlign(align: string): void {
        this.item.subtitleAlign = align;
    }

    setItemAlign(element: string, align: string) {
        this.item[element] = align;
    }

    isMulti() {
        let user: any = (localStorage.getItem('loggedUser') || sessionStorage.getItem('loggedUser'));
        if (user) {
            user = JSON.parse(user).data;
            let permission = user.resource_sub.find(s => s.tag == 'multi-account' && s.parent == 'editor-ead');
            if (permission) {
                return permission.enabled;
            }
        }

        return false;
    }

    getCompanies() {
        this.dataService.companies().subscribe((response: any) => {
            this.companies = response.data;
        });
    }

    selectCompany(company) {
        if (!this.item.companies) {
            this.item.companies = [];
            this.item.companies.push(company.id);
        }
        else if (!this.item.companies.includes(company.id)) {
            this.item.companies.push(company.id);
        }
        else {
            let idx = this.item.companies.indexOf(company.id);
            this.item.companies.splice(idx,1);
        }
    }

}
